/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
//DashboardOverview: { path: "/dashboard/overview" },
export const Routes = { 
    // HUB PAGES
    Waybill: { path: "/waybill"},
    arrived: { path: "/waybill/arrived"},
    WaybillImport: { path: "/waybill/import"},

    WaybillScan: { path: "/waybill/scan"},

    Receiver: { path: "/user"},
    ReceiverAddress: { path: "/user/address"},

    SystemUser: {path: "/system/user"},
    SystemSetting: {path: "/system/setting"},

    Signin: { path: "/sign-in" },    
    // pages
    DashboardOverview: { path: "/" },  
    Transactions: { path: "/transactions" },

    BundleSheet: { path: "/bundle/sheet" },

    Settings: { path: "/settings" },
    Upgrade: { path: "/upgrade" },
    BootstrapTables: { path: "/tables/bootstrap-tables" },
    Billing: { path: "/billing" },
    Invoice: { path: "/invoice" },
    
    Signup: { path: "/sign-up" },
    ForgotPassword: { path: "/forgot-password" },
    ResetPassword: { path: "/reset-password" },
    Lock: { path: "/lock" },
    NotFound: { path: "/404" },
    ServerError: { path: "/500" },
    
};